export default __webpack_public_path__ + "static/AA022511_GIVSP_1334-Ext_540x360-300x200-03f7cb5cb6263f06d22e00e7b7f223ba.jpg";